module.exports = __webpack_public_path__ + "img/logo.0a433024.svg";